import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { ownerApi } from './ownerClient'
import type { ShopSettings, UpdateShopPayload } from '../types'

/**
 * OWNER-only shop settings (§16 Phase 7) over `/api/shop` (gated to ROLE_OWNER on the backend).
 * The tenant is ambient (staff JWT + resolver); these never send a tenant id. The public,
 * read-only branding view stays separate (`/api/storefront/shop`, the storefront's `useShop`).
 */

async function fetchShopSettings(): Promise<ShopSettings> {
  const { data } = await ownerApi.get<ShopSettings>('/shop')
  return data
}

export function useShopSettings(enabled: boolean) {
  return useQuery({ queryKey: ['shopSettings'], queryFn: fetchShopSettings, enabled })
}

export function useUpdateShop() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: UpdateShopPayload) => {
      const { data } = await ownerApi.put<ShopSettings>('/shop', payload)
      return data
    },
    // Seed the cache with the server's canonical copy (blank-as-null normalized).
    onSuccess: (data) => queryClient.setQueryData(['shopSettings'], data),
  })
}
